module.exports = __webpack_public_path__ + "Icono_InfoPProductoTSI_512px.png";